import { gql } from '@apollo/client';

interface EIMDashboardRequest {
    month?: string;
    company?: string;
    group?: string;
    partnerno?: string;
    pageNumber?: number;
    pageSize?: number;
}

export const QUERY_DASH_CARDS_COUNT = gql`
    query getDashCardCount($request: EIMDashboardRequest!) {
        getDashCardCount(request: $request) {
            total
            inbound
            outbound
            pass
            overdue
            fail
            transit
            transb
        }
    }
`;



export const QUERY_COUNT_ALL_ACTIVE_PARTNERS = gql`
    query countAllActivePartners {
        countAllActivePartnerData {
            total
            groupCountData {
                group_id
                group_name
                total_active_partner
            }
        }
    }
`;


export const QUERY_ALL_ACTIVE_PARTNERS = gql`
    query AllActivePartners($request: EIMDashboardRequest!) {
        allActivePartnerData(request: $request) {
            month
            company
            partnerno
            group
            total
        }
    }
`;
export const QUERY_DOWNLOAD_ALL_ACTIVE_PARTNERS = gql`
    query DownloadAllActivePartners($request: EIMDashboardRequest!) {
        allActivePartnerDataDownload(request: $request) {
            month
            company
            partnerno
            group
            total
        }
    }
`;

export const QUERY_EIM_PARTNERS_BY_PARTNER_NO = gql`
    query allPartnersByPartnerNo($partnerNo: String!) {
        allPartnersByPartnerNo(partnerNo: $partnerNo) {
            partnerNo
            partnerName
            systemCode
            companyCode
        }
    }
`;

export const QUERY_EIM_ACTIVE_PARTNER_INVOICE_SUMMARY = gql`
    query allActivePartnerInvoiceSummary($request: EIMDashboardRequest!) {
        allActivePartnerInvoiceSummary(request: $request) {
            partnerno
            partnerName
            company
            total
        }
    }
`;

export const QUERY_EIM_ACTIVE_PARTNER_INVOICE_HOURLY_TREND = gql`
    query allActivePartnerInvoiceHourlyTrend($request: EIMDashboardRequest!) {
        allActivePartnerInvoiceHourlyTrend(request: $request) {
            hourLabel
            successfulCount
            failedCount
        }
    }
`;

export const QUERY_EIM_ACTIVE_PARTNER_COUNTRY_DETAIL = gql`
    query allActivePartnerCountryDetail($request: EIMDashboardRequest!) {
        allActivePartnerCountryDetail(request: $request) {
            metrics {
                totalProcessed
                successfulCount
                failedCount
                overdueCount
                inTransitCount
                stpRate
                failureRate
                avgTransitDays
            }
            topPartners {
                partnerno
                partnerName
                company
                total
            }
            hourlyTrend {
                hourLabel
                successfulCount
                failedCount
            }
            topErrorMessages {
                message
                count
                percentage
            }
        }
    }
`;

export const QUERY_EIM_ACTIVE_PARTNER_COUNTRY_METRICS = gql`
    query allActivePartnerCountryMetrics($request: EIMDashboardRequest!) {
        allActivePartnerCountryMetrics(request: $request) {
            country
            companyCode
            intake {
                totalProcessed
                inboundCount
                outboundCount
            }
            processing {
                stpRate
                onTimeRate
                avgTransitDays
                inTransitCount
            }
            exceptions {
                failedCount
                overdueCount
                failureRate
            }
            coverage {
                activePartners
                totalPartners
                coverageRate
            }
        }
    }
`;

export const QUERY_EIM_EXECUTIVE_DASHBOARD = gql`
    query eimExecutiveDashboard($request: EIMExecutiveDashboardRequest!) {
        eimExecutiveDashboard(request: $request) {
            volume {
                totalProcessed
                inboundCount
                outboundCount
                previousPeriodTotal
                volumeDelta
                failedCount
                inTransitCount
                busnTransitCount
                failureRate
                failureRateTarget
                failureRateThreshold
                volumeTrendByMonth {
                    month
                    total
                    failed
                    stpRate
                }
            }
            flowHealth {
                stpRate
                previousStpRate
                stpDelta
                stpTarget
                stpThreshold
                onTimeRate
                previousOnTimeRate
                onTimeDelta
                onTimeTarget
                onTimeThreshold
                avgTransitDays
                previousAvgTransitDays
                transitDelta
                stpRateTrendByMonth {
                    month
                    stpRate
                    onTimeRate
                    avgTransitDays
                }
                stpRateTrendByDay {
                    month
                    stpRate
                    onTimeRate
                    avgTransitDays
                }
                stpRateTrendByYear {
                    month
                    stpRate
                    onTimeRate
                    avgTransitDays
                }
            }
            risk {
                overdueCount
                previousOverdueCount
                overdueDelta
                overdueTarget
                overdueThreshold
                failedCount
                failureRate
                previousFailureRate
                failureRateDelta
                failureRateTarget
                failureRateThreshold
                agingBuckets {
                    ageRange
                    count
                    percentage
                }
                overdueTrendByMonth {
                    month
                    overdueCount
                }
            }
            coverage {
                activePartners
                totalPartners
                coverageRate
                previousCoverageRate
                coverageDelta
                coverageTarget
                coverageThreshold
                monthlyNewPartners
                topImpactedGroups {
                    groupName
                    failureRate
                    overdueCount
                    volume
                    riskRanking
                }
                coverageTrendByMonth {
                    month
                    coverageRate
                    activePartnerCount
                }
            }
            metadata {
                dataAsOf
                lastRefresh
                appliedFilters {
                    periodStart
                    periodEnd
                    processType
                    partnerGroup
                }
                compositeHealthScore
                healthScoreLabel
            }
        }
    }
`;

export const QUERY_EIM_EXECUTIVE_DASHBOARD_V2 = gql`
    query eimExecutiveDashboardV2($request: EIMExecutiveDashboardRequest!) {
        eimExecutiveDashboard(request: $request) {
            volume {
                totalProcessed
            }
            flowHealth {
                onTimeRate
                onTimeDelta
                avgTransitDays
            }
            coverage {
                coverageRate
                coverageThreshold
            }
            metadata {
                healthScoreLabel
            }
        }
    }
`;

export const QUERY_EIM_EXECUTIVE_DASHBOARD_COUNTRY_METRICS = gql`
    query eimExecutiveDashboardCountryMetrics($request: EIMExecutiveDashboardRequest!) {
        eimExecutiveDashboardCountryMetrics(request: $request) {
            country
            companyCode
            intake {
                totalProcessed
                inboundCount
                outboundCount
            }
            processing {
                stpRate
                onTimeRate
                avgTransitDays
                inTransitCount
            }
            exceptions {
                failedCount
                overdueCount
                failureRate
            }
            coverage {
                activePartners
                totalPartners
                coverageRate
            }
        }
    }
`;

export const QUERY_EIM_EXECUTIVE_DASHBOARD_SYSTEM_METRICS = gql`
    query eimExecutiveDashboardSystemMetrics($request: EIMExecutiveDashboardRequest!) {
        eimExecutiveDashboardSystemMetrics(request: $request) {
            systemId
            systemLabel
            intake {
                totalProcessed
                inboundCount
                outboundCount
            }
            processing {
                stpRate
                onTimeRate
                avgTransitDays
                inTransitCount
            }
            exceptions {
                failedCount
                overdueCount
                failureRate
            }
            coverage {
                activePartners
                totalPartners
                coverageRate
            }
        }
    }
`;

export const QUERY_EIM_EXECUTIVE_DASHBOARD_CHANNEL_METRICS = gql`
    query eimExecutiveDashboardChannelMetrics($request: EIMExecutiveDashboardRequest!) {
        eimExecutiveDashboardChannelMetrics(request: $request) {
            channel
            intake {
                totalProcessed
                inboundCount
                outboundCount
            }
            processing {
                stpRate
                onTimeRate
                avgTransitDays
                inTransitCount
            }
            exceptions {
                failedCount
                overdueCount
                failureRate
            }
            coverage {
                activePartners
                totalPartners
                coverageRate
            }
        }
    }
`;

export const QUERY_EIM_EXECUTIVE_DASHBOARD_FLOW_STAGE_METRICS = gql`
    query eimExecutiveDashboardFlowStageMetrics($request: EIMExecutiveDashboardRequest!) {
        eimExecutiveDashboardFlowStageMetrics(request: $request) {
            mProcess
            stage
            stepNumber
            transitionCount
            avgTransitDays
        }
    }
`;

export const QUERY_EIM_EXECUTIVE_DASHBOARD_GROUP_METRICS = gql`
    query eimExecutiveDashboardGroupMetrics($request: EIMExecutiveDashboardRequest!) {
        eimExecutiveDashboardGroupMetrics(request: $request) {
            groupName
            country
            totalInvoices
            successfulCount
            inTransitCount
            failedCount
        }
    }
`;

export const QUERY_EIM_EXECUTIVE_DASHBOARD_TOP_FAILURE_REASONS = gql`
    query eimExecutiveDashboardTopFailureReasons($request: EIMExecutiveDashboardRequest!) {
        eimExecutiveDashboardTopFailureReasons(request: $request) {
            reason
            invoiceCount
            percentage
            failedCount
            failureRate
            overdueCount
            volume
        }
    }
`;

export const QUERY_EIM_EXECUTIVE_DASHBOARD_TOP_FAILURE_PROCESSES = gql`
    query eimExecutiveDashboardTopFailureProcesses($request: EIMExecutiveDashboardRequest!) {
        eimExecutiveDashboardTopFailureProcesses(request: $request) {
            process
            failedCount
            totalCount
            failureRate
            overdueCount
        }
    }
`;

export const QUERY_EIM_EXECUTIVE_DASHBOARD_TOP_FAILURE_COMPANY_CODES = gql`
    query eimExecutiveDashboardTopFailureCompanyCodes($request: EIMExecutiveDashboardRequest!) {
        eimExecutiveDashboardTopFailureCompanyCodes(request: $request) {
            companyCode
            country
            failureRate
            overdueCount
            volume
            riskRanking
        }
    }
`;
